/**
 * Mock dashboard statistics data for MSP reporting prototype
 */

export interface DashboardStats {
  reports_this_month: number;
  scheduled_reports: number;
  active_customers: number;
  failed_reports: number;
  reports_generated_today: number;
  upcoming_scheduled_reports: number;
}

export const dashboardStatsMockData: DashboardStats = {
  reports_this_month: 247,
  scheduled_reports: 12,
  active_customers: 19, // Active customers from customers-mock-data
  failed_reports: 3,
  reports_generated_today: 8,
  upcoming_scheduled_reports: 5,
};
